import script from "./RedeemLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./RedeemLogs.vue?vue&type=script&setup=true&lang=js"

import "./RedeemLogs.vue?vue&type=style&index=0&id=b616a3cc&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b616a3cc"]])

export default __exports__